import { IconProps } from "./types";

export default function IcoClose({ size = "24" }: Readonly<IconProps>) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20.0003 4L11.7702 12.2265M11.7702 12.2265L4.45215 19.5413M11.7702 12.2265L19.5472 20M11.7702 12.2265L3.99902 4.45865"
				stroke="#1D1D1D"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
